/* eslint-disable react/forbid-prop-types,import/no-unresolved */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isBrowser, isMobile } from 'react-device-detect';
import { useHistory, useLocation } from 'react-router-dom';
import { EmptyYieldListImage } from 'assets/components';
import { YieldItemPlaceholder } from '../../../components/Placeholders';
import { MODAL_SCREENS, yieldTypes } from '../constants';
import OfferListContainer from './OfferListContainer';
import DepositedItemLayout from './DepositedItemLayout';
import ReceivedItemLayout from './ReceivedItemLayout';
import { alphaSort } from '../../../utilities/helpers';
import OfferItemLayout from './OfferItemLayout';

const YieldList = ({
  offerList,
  depositedList,
  receivedList,
  type,
  isOffersLoading,
  isDepositedLoading,
  isReceivedLoading,
  showScreen,
  setDetails,
  setDepositDetails,
  setReceivedDetails,
}) => {
  const { t: translate } = useTranslation();

  const history = useHistory();
  const location = useLocation();

  const handleGoToOffers = (current) => {
    history.replace({ pathname: location.pathname.replace(current, yieldTypes.OFFERS) });
  };

  const [sortingOptions, setSortingOptions] = useState({
    sortDefaultKey: 'expirationDate',
    expirationDate: {
      enabled: false,
      ascending: false,
      castToNumber: false,
      isDate: true,
    },
    annualizedYieldPct: {
      enabled: false,
      ascending: false,
      castToNumber: true,
      isDate: false,
    },
    settleCoinEffectivePurchasePrice: {
      enabled: false,
      ascending: false,
      castToNumber: true,
      isDate: false,
    },
  });

  const [sortingInvestedOptions, setSortingInvestedOptions] = useState({
    sortDefaultKey: 'expirationDate',
    expirationDate: {
      enabled: false,
      ascending: false,
      castToNumber: false,
      isDate: true,
    },
    annualizedYield: {
      enabled: false,
      ascending: false,
      castToNumber: true,
      isDate: false,
    },
    duration: {
      enabled: false,
      ascending: false,
      castToNumber: true,
      isDate: false,
    },
    settleCoinEffectivePurchasePrice: {
      enabled: false,
      ascending: false,
      castToNumber: true,
      isDate: false,
    },
    depositedAmount: {
      enabled: false,
      ascending: false,
      castToNumber: true,
      isDate: false,
    },
  });

  const [sortingReceivedOptions, setSortingReceivedOptions] = useState({
    sortDefaultKey: 'expirationDate',
    expirationDate: {
      enabled: false,
      ascending: false,
      castToNumber: false,
      isDate: true,
    },
    annualizedYield: {
      enabled: false,
      ascending: false,
      castToNumber: true,
      isDate: false,
    },
    duration: {
      enabled: false,
      ascending: false,
      castToNumber: true,
      isDate: false,
    },
    settleCoinEffectivePurchasePrice: {
      enabled: false,
      ascending: false,
      castToNumber: true,
      isDate: false,
    },
    depositedAmount: {
      enabled: false,
      ascending: false,
      castToNumber: true,
      isDate: false,
    },
  });

  const handleSortWallets = (yieldType, columnKey) => {
    if (yieldType === yieldTypes.OFFERS) {
      const newSortingOptions = {};
      Object.keys(sortingOptions)
        .filter((option) => option !== columnKey)
        .forEach((option) => {
          newSortingOptions[option] = { ...sortingOptions[option], enabled: false };
        });

      setSortingOptions((prev) => ({
        ...newSortingOptions,
        sortDefaultKey: columnKey,
        [columnKey]: {
          ...prev[columnKey],
          enabled: !prev[columnKey].enabled,
          ascending: !prev[columnKey].ascending,
        },
      }));
    }
    if (yieldType === yieldTypes.DEPOSITED) {
      const newSortingOptions = {};
      Object.keys(sortingInvestedOptions)
        .filter((option) => option !== columnKey)
        .forEach((option) => {
          newSortingOptions[option] = { ...sortingInvestedOptions[option], enabled: false };
        });

      setSortingInvestedOptions((prev) => ({
        ...newSortingOptions,
        sortDefaultKey: columnKey,
        [columnKey]: {
          ...prev[columnKey],
          enabled: !prev[columnKey].enabled,
          ascending: !prev[columnKey].ascending,
        },
      }));
    }
    if (yieldType === yieldTypes.RECEIVED) {
      const newSortingOptions = {};
      Object.keys(sortingReceivedOptions)
        .filter((option) => option !== columnKey)
        .forEach((option) => {
          newSortingOptions[option] = { ...sortingReceivedOptions[option], enabled: false };
        });

      setSortingReceivedOptions((prev) => ({
        ...newSortingOptions,
        sortDefaultKey: columnKey,
        [columnKey]: {
          ...prev[columnKey],
          enabled: !prev[columnKey].enabled,
          ascending: !prev[columnKey].ascending,
        },
      }));
    }
  };

  const _sortLabelsReceived = useMemo(
    () => [
      {
        id: 0,
        title: translate('oxygen_annualized_filter_label'),
        withIcon: true,
        onClick: () => handleSortWallets(yieldTypes.RECEIVED, 'annualizedYield'),
        classes: 'col-3',
        isMobile: true,
        enabled: sortingReceivedOptions.annualizedYield.enabled,
      },
      {
        id: 1,
        title: translate('oxygen_duration_filter_label'),
        onClick: () => handleSortWallets(yieldTypes.RECEIVED, 'duration'),
        withIcon: true,
        classes: 'col-2 ps-0',
        isMobile: false,
        enabled: sortingReceivedOptions.duration.enabled,
      },
      {
        id: 2,
        title: translate('oxygen_effective_purchase_filter_label'),
        onClick: () => handleSortWallets(yieldTypes.RECEIVED, 'settleCoinEffectivePurchasePrice'),
        withIcon: true,
        classes: 'col-3 ps-0',
        isMobile: false,
        enabled: sortingReceivedOptions.settleCoinEffectivePurchasePrice.enabled,
      },
      {
        id: 3,
        title: '',
        onClick: () => {},
        withIcon: false,
        classes: 'col-3',
        isMobile: false,
        enabled: false,
      },
      {
        id: 4,
        title: translate('actions_label'),
        withIcon: false,
        isRight: true,
        classes: 'col-1',
        isMobile: false,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [sortingReceivedOptions]
  );

  const _sortLabelsInvested = useMemo(
    () => [
      {
        id: 0,
        title: translate('oxygen_annualized_filter_label'),
        withIcon: true,
        onClick: () => handleSortWallets(yieldTypes.DEPOSITED, 'annualizedYield'),
        classes: 'col-3',
        isMobile: true,
        enabled: sortingInvestedOptions.annualizedYield.enabled,
      },
      {
        id: 1,
        title: translate('oxygen_duration_filter_label'),
        onClick: () => handleSortWallets(yieldTypes.DEPOSITED, 'duration'),
        withIcon: true,
        classes: 'col-2 ps-0',
        isMobile: false,
        enabled: sortingInvestedOptions.duration.enabled,
      },
      {
        id: 2,
        title: translate('oxygen_effective_purchase_filter_label'),
        onClick: () => handleSortWallets(yieldTypes.DEPOSITED, 'settleCoinEffectivePurchasePrice'),
        withIcon: true,
        classes: 'col-3 ps-0',
        isMobile: false,
        enabled: sortingInvestedOptions.settleCoinEffectivePurchasePrice.enabled,
      },
      {
        id: 3,
        title: translate('oxygen_yield_deposited_tab_label'),
        onClick: () => handleSortWallets(yieldTypes.DEPOSITED, 'depositedAmount'),
        withIcon: true,
        classes: 'col-3',
        isMobile: false,
        enabled: sortingInvestedOptions.depositedAmount.enabled,
      },
      {
        id: 4,
        title: translate('actions_label'),
        withIcon: false,
        isRight: true,
        classes: 'col-1',
        isMobile: false,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [sortingInvestedOptions]
  );

  const _sortLabelsOffers = useMemo(
    () => [
      {
        id: 0,
        title: translate('oxygen_annualized_filter_label'),
        withIcon: true,
        onClick: () => handleSortWallets(yieldTypes.OFFERS, 'annualizedYieldPct'),
        enabled: sortingOptions.annualizedYieldPct.enabled,
        isMobile: true,
      },
      {
        id: 1,
        title: translate('oxygen_duration_filter_label'),
        onClick: () => handleSortWallets(yieldTypes.OFFERS, 'expirationDate'),
        enabled: sortingOptions.expirationDate.enabled,
        withIcon: true,
        isMobile: false,
      },
      {
        id: 2,
        title: translate('oxygen_effective_purchase_filter_label'),
        onClick: () => handleSortWallets(yieldTypes.OFFERS, 'settleCoinEffectivePurchasePrice'),
        enabled: sortingOptions.settleCoinEffectivePurchasePrice.enabled,
        withIcon: true,
        isMobile: false,
      },
      {
        id: 3,
        isMobile: false,
        hidden: true,
      },
      {
        id: 4,
        title: translate('actions_label'),
        enabled: false,
        withIcon: false,
        isRight: true,
        isMobile: false,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [sortingOptions]
  );

  const sortLabels = useMemo(() => {
    if (type === yieldTypes.OFFERS) {
      return _sortLabelsOffers;
    }
    if (type === yieldTypes.DEPOSITED) {
      return _sortLabelsInvested;
    }
    return _sortLabelsReceived;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, sortingOptions, sortingInvestedOptions, sortingReceivedOptions]);

  const sortedDepositedList = useMemo(() => {
    if (depositedList && Array.isArray(depositedList)) {
      const comparerFn = (a, b) =>
        alphaSort(
          a,
          b,
          sortingInvestedOptions?.sortDefaultKey,
          sortingInvestedOptions[sortingInvestedOptions?.sortDefaultKey].ascending,
          sortingInvestedOptions[sortingInvestedOptions?.sortDefaultKey].castToNumber,
          sortingInvestedOptions[sortingInvestedOptions?.sortDefaultKey].isDate
        );

      return depositedList.sort(comparerFn);
    }
    return [];
  }, [sortingInvestedOptions, depositedList]);

  const sortedReceivedList = useMemo(() => {
    if (receivedList && Array.isArray(receivedList)) {
      const comparerFn = (a, b) =>
        alphaSort(
          a,
          b,
          sortingReceivedOptions?.sortDefaultKey,
          sortingReceivedOptions[sortingReceivedOptions?.sortDefaultKey].ascending,
          sortingReceivedOptions[sortingReceivedOptions?.sortDefaultKey].castToNumber,
          sortingReceivedOptions[sortingReceivedOptions?.sortDefaultKey].isDate
        );

      return receivedList.sort(comparerFn);
    }
    return [];
  }, [sortingReceivedOptions, receivedList]);

  const sortedOfferList = useMemo(() => {
    if (offerList && Array.isArray(offerList)) {
      let sortedList = offerList;

      if (sortingOptions?.sortDefaultKey !== 'expirationDate') {
        const comparerFn = (a, b) =>
          alphaSort(
            a,
            b,
            sortingOptions?.sortDefaultKey,
            sortingOptions[sortingOptions?.sortDefaultKey].ascending,
            sortingOptions[sortingOptions?.sortDefaultKey].castToNumber,
            sortingOptions[sortingOptions?.sortDefaultKey].isDate
          );
        sortedList = sortedList.map((item) => {
          const sortedProducts = item.products.sort(comparerFn);
          return { expirationDate: item.expirationDate, products: sortedProducts };
        });
      } else {
        const comparerFn = (a, b) =>
          alphaSort(
            a,
            b,
            'annualizedYieldPct',
            true,
            sortingOptions.annualizedYieldPct.castToNumber,
            sortingOptions.annualizedYieldPct.isDate
          );
        sortedList = sortedList.map((item) => {
          const sortedProducts = item.products.sort(comparerFn);
          return { expirationDate: item.expirationDate, products: sortedProducts };
        });
      }

      const comparerFn = (a, b) =>
        alphaSort(
          a,
          b,
          'expirationDate',
          sortingOptions.expirationDate.ascending,
          sortingOptions.expirationDate.castToNumber,
          sortingOptions.expirationDate.isDate
        );

      return sortedList.sort(comparerFn);
    }
    return [];
  }, [sortingOptions, offerList]);

  const renderSortLabelsMobileLayout = () => (
    <div className="d-flex flex-row px-3 w-100 mt-4">
      {sortLabels
        .filter((item) => item.isMobile)
        .map((item) => {
          const attribs = {};
          if (item.withIcon) {
            attribs.tabIndex = '0';
            attribs.role = 'button';
            attribs.onClick = item.onClick;
            attribs.onKeyDown = () => {};
          }

          return (
            <div key={item.id} className="d-flex flex-row justify-content-start align-items-center">
              <span {...attribs}>
                <img
                  alt="sort"
                  src="./assets/images/sort.svg"
                  className="me-1"
                  style={{ width: '1rem', height: '1rem' }}
                />
                <span className="text-shadow text-f6">{item.title}</span>
              </span>
            </div>
          );
        })}
    </div>
  );

  const renderSortLabels = () => (
    <div className="container-fluid p-0 mt-4">
      <div className="row w-100 m-auto">
        {sortLabels
          .filter((item) => !item.hidden)
          .map((item, index) => {
            const attribs = {};
            if (item.withIcon) {
              attribs.tabIndex = '0';
              attribs.role = 'button';
              attribs.onClick = item.onClick;
              attribs.onKeyDown = () => {};
            }

            return (
              <div
                className={`${item.classes ? item.classes : 'col'} ${index === 0 ? 'px-0' : ''} ${
                  index === sortLabels.length - 1 ? 'pe-0' : ''
                }`}
                key={item.id}>
                <span
                  key={item.id}
                  style={item.isRight ? { marginLeft: 'auto' } : {}}
                  className={`${
                    item?.enabled ? 'text-primary' : 'text-shadow'
                  } text-f6 text-start text-nowrap d-flex flex-even align-items-center position-relative ${
                    item.isRight ? 'justify-content-end' : ''
                  } ${item.classes}`}
                  {...attribs}>
                  <span>
                    {item.withIcon ? (
                      <img
                        alt="sort"
                        src="./assets/images/sort.svg"
                        className="me-1"
                        style={{ width: '1rem', height: '1rem' }}
                      />
                    ) : null}
                    <span>{item.title}</span>
                  </span>
                </span>
              </div>
            );
          })}
      </div>
    </div>
  );

  const allOffers = useMemo(() => {
    if (offerList && Array.isArray(offerList)) {
      const comparerFn = (a, b) =>
        alphaSort(
          a,
          b,
          sortingOptions?.sortDefaultKey,
          sortingOptions[sortingOptions?.sortDefaultKey].ascending,
          sortingOptions[sortingOptions?.sortDefaultKey].castToNumber,
          sortingOptions[sortingOptions?.sortDefaultKey].isDate
        );

      const allOffersItems = offerList.reduce(
        (accumulator, offerGroup) => [...accumulator, ...offerGroup.products],
        []
      );

      return allOffersItems.sort(comparerFn);
    }
    return [];
  }, [offerList, sortingOptions]);

  const renderList = () => {
    if (offerList && type === yieldTypes.OFFERS) {
      return sortingOptions?.sortDefaultKey === 'expirationDate'
        ? sortedOfferList.map((item, index) => (
            <OfferListContainer
              key={item?.expirationDate}
              date={index > 0 ? item?.expirationDate : ''}
              data={item?.products}
              showDepositOffer={showScreen}
              setDetails={setDetails}
            />
          ))
        : allOffers.map((offer) => (
            <OfferItemLayout
              key={`${offer?.id}`}
              item={offer}
              onDepositClick={() => {
                setDetails(offer);
                showScreen(MODAL_SCREENS.DEPOSIT);
              }}
            />
          ));
    }
    if (depositedList && type === yieldTypes.DEPOSITED) {
      return sortedDepositedList?.map((item) => (
        <DepositedItemLayout
          key={`${item?.id}`}
          item={item}
          showScreen={showScreen}
          onDetailsClick={setDepositDetails}
        />
      ));
    }
    if (receivedList && type === yieldTypes.RECEIVED) {
      return sortedReceivedList?.map((item) => (
        <ReceivedItemLayout
          key={`${item?.id}`}
          item={item}
          showScreen={showScreen}
          onDetailsClick={setReceivedDetails}
        />
      ));
    }
    return <></>;
  };

  const renderEmptyList = () => {
    if (type === yieldTypes.DEPOSITED || type === yieldTypes.RECEIVED) {
      return (
        <div
          className={`w-100 ${
            isBrowser ? 'h-100' : 'h-auto'
          } d-flex justify-content-start flex-column align-items-center`}
          style={{ paddingTop: isBrowser ? '6rem' : '4rem' }}>
          {isBrowser && <EmptyYieldListImage />}
          <p className="text-dard text-f5 mt-3">
            {type === yieldTypes.DEPOSITED
              ? translate('yield_no_active_deposit')
              : translate('yield_no_finished_received')}
          </p>
          <button
            className="text-f6 btn btn-primary text-nowrap py-1 mt-3 px-4"
            onClick={() => handleGoToOffers(type)}
            type="button">
            {translate('yield_go_to_offers_btn_label')}
          </button>
        </div>
      );
    }
    return <></>;
  };

  const showSortLabelsAndList =
    (type === yieldTypes.OFFERS && Object.keys(offerList).length > 0) ||
    (type === yieldTypes.DEPOSITED && depositedList.length > 0) ||
    (type === yieldTypes.RECEIVED && receivedList.length > 0);

  const showLoading =
    (type === yieldTypes.OFFERS && isOffersLoading) ||
    (type === yieldTypes.DEPOSITED && isDepositedLoading) ||
    (type === yieldTypes.RECEIVED && isReceivedLoading);

  const showEmptyList =
    !showLoading &&
    ((type === yieldTypes.OFFERS && Object.keys(offerList).length === 0) ||
      (type === yieldTypes.DEPOSITED && depositedList.length === 0) ||
      (type === yieldTypes.RECEIVED && receivedList.length === 0));

  return (
    <>
      {isBrowser && showSortLabelsAndList && renderSortLabels()}
      {isMobile && showSortLabelsAndList && renderSortLabelsMobileLayout()}
      <div
        className={`container-fuild overflow-auto h-65vh  ${isBrowser ? 'mt-1 pe-3' : 'px-3'}`}
        style={{
          width: isBrowser ? `calc(100% + 1rem)` : '100%',
          marginBottom: isBrowser ? '' : '2rem',
        }}>
        {showEmptyList && renderEmptyList()}
        {!showLoading && showSortLabelsAndList && renderList()}
        {showLoading && (
          <div className="mt-3">
            <YieldItemPlaceholder />
            <YieldItemPlaceholder />
            <YieldItemPlaceholder />
            <YieldItemPlaceholder />
            <YieldItemPlaceholder />
            <YieldItemPlaceholder />
          </div>
        )}
      </div>
    </>
  );
};

YieldList.propTypes = {
  offerList: PropTypes.array,
  depositedList: PropTypes.array,
  receivedList: PropTypes.array,
  type: PropTypes.string.isRequired,
  isOffersLoading: PropTypes.bool.isRequired,
  isDepositedLoading: PropTypes.bool.isRequired,
  isReceivedLoading: PropTypes.bool.isRequired,
  showScreen: PropTypes.func.isRequired,
  setDetails: PropTypes.func.isRequired,
  setDepositDetails: PropTypes.func.isRequired,
  setReceivedDetails: PropTypes.func.isRequired,
};

YieldList.defaultProps = {
  offerList: [],
  depositedList: [],
  receivedList: [],
};

export default YieldList;
